module.exports = __webpack_public_path__ + "static/media/segment3.4168d19f.png";